import styled from 'styled-components';
import { Button, Form } from 'semantic-ui-react';

export const AttachmentFormGroup = styled(Form.Group)`
  align-items: baseline;
`;

export const AttachmentWrapper = styled.div`
  border-radius: 10px !important;
  position: relative;
`;

export const StyledDeleteButton = styled(Button)`
  cursor: pointer;
`;
